import { render, staticRenderFns } from "./TransferAmountInput.vue?vue&type=template&id=321ceb00&scoped=true"
import script from "./TransferAmountInput.vue?vue&type=script&lang=js"
export * from "./TransferAmountInput.vue?vue&type=script&lang=js"
import style0 from "./TransferAmountInput.vue?vue&type=style&index=0&id=321ceb00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ceb00",
  null
  
)

export default component.exports